export default {
    animation: Boolean | Object,
    autoWidth: Boolean,
    dataSource: Object | Array,
    clearButton: Boolean,
    dataTextField: String,
    delay: Number,
    enable: Boolean,
    enforceMinLength: Boolean,
    filter: String,
    fixedGroupTemplate: String | Function,
    footerTemplate: String | Function,
    groupTemplate: String | Function,
    height: Number,
    highlightFirst: Boolean,
    ignoreCase: Boolean,
    minLength: Number,
    noDataTemplate: String | Function,
    placeholder: String,
    popup: Object,
    separator: String | Array,
    suggest: Boolean,
    headerTemplate: String | Function,
    template: String | Function,
    value: String | Number,
    valuePrimitive: Boolean,
    virtual: Boolean | Object,

    // Events
    change: Function,
    close: Function,
    dataBound: Function,
    filtering: Function,
    open: Function,
    select: Function
}


// WEBPACK FOOTER //
// ./packages/kendo-dropdowns-vue-wrapper/src/KendoAutoComplete/AutoCompleteProps.js